module.exports = __webpack_public_path__ + "static/media/calculate.95b31534.wav";